// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

// load fonts
WebFont.load({
    google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
        families: ['Inter:400,500,700&display=swap']
    },
    //,
    // typekit: {
    // id: 'XXXX'
    // },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});

//Load Libraries
require('magnific-popup/dist/jquery.magnific-popup.min');
require('datatables.net');
require('datatables.net-colreorder');

//Load Modules
require('./modules/accordion');
require('./modules/bannerVideo');
require('./modules/copyLink');
require('./modules/dataTables');
require('./modules/developmentModal');
require('./modules/favourites');
require('./modules/filterInfo');
require('./modules/footer');
require('./modules/formInputs');
require('./modules/menu');
require('./modules/sliders');
require('./modules/statistics');
require('./modules/tabs');
require('./modules/videoButtonReplacer');
require('./modules/videoPopup');
